import { ClipLoader } from '@hqo/react-components-library/dist/atoms/loader';
import { LoaderWrapper } from './visit-modal.styles';

export const VisitModalLoader = (): JSX.Element => (
  <LoaderWrapper>
    <ClipLoader color="currentColor" />
  </LoaderWrapper>
);
